import { MainLayout } from "../../layouts";
import { AnimateLoader } from '../AnimateLoader';
import styles from './style.module.scss';

const AppLoader = ({ isFull }: { isFull: boolean }) => {
    if (isFull) {
        return (
            <MainLayout>
                <div className={styles.container}>
                    <AnimateLoader />
                </div>
            </MainLayout>
        );
    }

    return <div className={styles.container}>
        <AnimateLoader />
    </div>;
};

export default AppLoader;
